/**
 * Shared HandOverEmbedSessionModal.
 * embed session を Slack mention の root node として引き継ぐためのモーダル。
 * 引き継ぎ元 mention の Slack URL を入力すると extractSlackInfo (CreateSessionModal と
 * 同じ parse logic) で (threadTs, channelId) を抽出し、引き継ぎ先 mention に移動する。
 */
import type { FC } from "react"
import { useState } from "react"

import { extractSlackInfo } from "./CreateSessionModal"

import styles from "../TaigaSheetDetailPage.module.scss"

const HandOverEmbedSessionModal: FC<{
	onClose: () => void
	onSubmit: (threadTs: string, channelId: string) => void
	isLoading: boolean
}> = ({ onClose, onSubmit, isLoading }) => {
	const [slackUrl, setSlackUrl] = useState("")
	const [slackUrlError, setSlackUrlError] = useState("")

	const handleSubmit = () => {
		const info = extractSlackInfo(slackUrl.trim())
		if (!info) {
			setSlackUrlError("Invalid Slack URL")
			return
		}
		setSlackUrlError("")
		onSubmit(info.threadTs, info.channelId)
	}

	return (
		<div className={styles.modalOverlay} onClick={onClose}>
			<div className={styles.modal} onClick={(e) => e.stopPropagation()}>
				<h3 className={styles.modalTitle}>embed 引き継ぎ</h3>
				<p className={styles.modalHint}>
					引き継ぎ元 mention の Slack URL を貼り付けてください。その embed
					session がこの mention の root node として追加され、引き継ぎ元の
					mention は done になります。
				</p>
				<div className={styles.modalField}>
					<label>引き継ぎ元 Slack URL</label>
					<input
						className={`${styles.attachInput}${slackUrlError ? ` ${styles.attachInputError}` : ""}`}
						type="text"
						placeholder="https://souhl-inc.slack.com/archives/..."
						value={slackUrl}
						onChange={(e) => {
							setSlackUrl(e.target.value)
							if (slackUrlError) setSlackUrlError("")
						}}
						onKeyDown={(e) => {
							if (
								e.key === "Enter" &&
								!e.nativeEvent.isComposing &&
								slackUrl.trim() &&
								!isLoading
							) {
								e.preventDefault()
								handleSubmit()
							}
							if (e.key === "Escape") {
								e.preventDefault()
								onClose()
							}
						}}
						autoFocus
					/>
					{slackUrlError && (
						<span className={styles.attachError}>{slackUrlError}</span>
					)}
				</div>
				<div className={styles.modalActions}>
					<button
						className={styles.cancelBtn}
						onClick={onClose}
						disabled={isLoading}
					>
						Cancel
					</button>
					<button
						className={styles.createBtn}
						onClick={handleSubmit}
						disabled={!slackUrl.trim() || isLoading}
					>
						{isLoading ? "引き継ぎ中..." : "引き継ぐ"}
					</button>
				</div>
			</div>
		</div>
	)
}

export default HandOverEmbedSessionModal
